import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { ClientStageList } from '../models/client-stage-list';
import { ProductLicense } from '../models/product-license';
import { SystemConfigUpdateRequest } from '../models/system-config-update-request';
import { SystemConfigValue } from '../models/system-config-value';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {

  private baseUrl: string = '';
  private apiController: string = '';
  private appConfig!: AppConfigurations;

  constructor(private http: HttpClient, private appInitService: AppInitService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.adminApi.baseApiUrl;
    this.apiController = this.appConfig.adminApi.systemConfigController;
  }

  public setSystemConferencingProvider(provider: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}${this.apiController}/setConferencingProvider?provider=${provider}`, {});
  }

  public getSystemConfigurationForRoot(): Observable<SystemConfigValue[]> {
    return this.http.get<SystemConfigValue[]>(`${this.baseUrl}${this.apiController}?hierarchyid=/`)
      .pipe(
        catchError(this.handleError<SystemConfigValue[]>('getSystemConfigurationForRoot', []))
      );
  }

  public getSystemConfigurationForSignInUser(locationId: number, userId: number): Observable<SystemConfigValue[]> {
    return this.http.get<SystemConfigValue[]>(`${this.baseUrl}${this.apiController}/location/` + locationId + `/activeConfigurationsforUser/` + userId)
      .pipe(
        catchError(this.handleError<SystemConfigValue[]>('getSystemConfigurationForSignInUser', []))
      );
  }

  public updateSystemConfigurationValues(systemConfigUpdateRequests: SystemConfigUpdateRequest[]): Observable<boolean> {
    return this.http.patch<boolean>(`${this.baseUrl}${this.apiController}`, systemConfigUpdateRequests)
      .pipe(
        catchError(this.handleError<boolean>('updateSystemConfigurationValues', false))
      );
  }
  public updateLicenseConfigurationValues(productLicenses: ProductLicense[]): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}${this.apiController}/productlicense`, productLicenses);
  }

  public checkForCanDisableProductLicense(productId: number): Observable<any> {
    const url = `${this.baseUrl}${this.apiController}/permissionlicense/${productId}`;
    return this.http.get<any>(url);
  }

  public getClientStages(): Observable<ClientStageList[]> {
    let url = `${this.baseUrl}${this.apiController}/getClientStages/`;
    return this.http.get<ClientStageList[]>(url);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  authorizeProvider(authorizedData: any): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}${this.apiController}/authorizeConferencingProvider`, authorizedData);
  }

  public validateGlia(siteId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${this.apiController}/validateGlia/`+ siteId);
  }
}
